import { render, staticRenderFns } from "./loading-menu.vue?vue&type=template&id=3e4b30c8&"
import script from "./loading-menu.vue?vue&type=script&lang=js&"
export * from "./loading-menu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports